export const checkFileExtension = (fileName: string, extensions: string[] = ['pdf', 'png', 'jpeg', 'jpg']) => {
  const extension = fileName.split('.').pop();
  return extensions.includes(extension);
};
